import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { useWindowWidth } from '@shared/hooks';

import { Orders } from '../orders';
import { Products } from '../products';

export const SearchPage: FC = () => {
	const navigate = useNavigate();
	const windowWidth = useWindowWidth();

	const whatPage = location.pathname.indexOf('products') !== -1 ? 'products' : 'orders';

	return (
		<>
			{whatPage === 'products' && windowWidth <= 480 && <Products />}
			{whatPage === 'products' && windowWidth > 480 && navigate(`/shop/store/products`)}
			{whatPage === 'orders' && windowWidth <= 480 && <Orders />}
			{whatPage === 'orders' && windowWidth <= 480 && navigate(`/shop/store/orders`)}
		</>
	);
};
